import { Checkbox } from "@mui/material";
import { columns } from "../../../../dtos/columns";
import { MutuosARecaudar } from "../models/mutuosARecaudar";
import { RowRecaudacionEndosoMasivo } from "../models/rowRecaudacionEndosoMasivo";
import Conversiones from "../../../../utils/conversiones";
import { numericFormatter } from "react-number-format";

interface IProps {
    mutuosRecaudar: MutuosARecaudar[];
    data: any,
    setMutuosRecaudar: React.Dispatch<React.SetStateAction<MutuosARecaudar[]>>;
}

export function UseColumns({mutuosRecaudar, data, setMutuosRecaudar} : IProps){

    const COLUMNS: columns<RowRecaudacionEndosoMasivo>[] = [
        {
            name: (
                <Checkbox
                    size="small"
                    checked={
                        data?.length > 0 &&
                        mutuosRecaudar.length === data.length
                    }
                    onChange={(e) => {
                        if (e.target.checked && data) {
                            const allObjects = data.map((item: MutuosARecaudar) => ({
                                mutuoId: item.mutuoId,
                            }));
                            setMutuosRecaudar(allObjects);
                        } else {
                            setMutuosRecaudar([]);
                        }
                    }}
                />
            ),
            selector: (row: RowRecaudacionEndosoMasivo) => row.mutuoId,
            cell: (row: RowRecaudacionEndosoMasivo) => (
                <Checkbox
                    size="small"
                    checked={mutuosRecaudar.some((m) => m.mutuoId === row.mutuoId)}
                    onChange={(e) => {
                        setMutuosRecaudar((prev) => {
                            if (e.target.checked) {
                                return [
                                    ...prev,
                                    {
                                        mutuoId: row.mutuoId
                                    },
                                ];
                            } else {
                                return prev.filter((m) => m.mutuoId !== row.mutuoId);
                            }
                        });
                    }}
                />
            ),
            allowOverflow: true,
            button: true,
            export: false,
            width: '60px',
        },
        {
            name: 'N° operación',
            selector: (row: RowRecaudacionEndosoMasivo) => row.numeroOperacion,
            sortable: true,
            sortField: 'numeroOperacion',
            wrap: true,
            alling: 'left',
            export: true,
        },
        {
            name: 'Tasa endoso',
            selector: (row: RowRecaudacionEndosoMasivo) => row.tasaEndoso,
            sortable: true,
            sortField: 'tasaEndoso',
            wrap: true,
            alling: 'left',
            export: true,
        }, 
        {
            name: "Fecha endoso",
            selector: (row: RowRecaudacionEndosoMasivo) => Conversiones.fechaCortaFormat((row.fechaEndoso ?? "").toString()),
            sortable: true,
            sortField: 'fechaEndoso',
            wrap: true,
            export: true,
            alling: 'left',
        },
        {
            name: 'Monto nominal',
            selector: (row: RowRecaudacionEndosoMasivo) => numericFormatter(row.montoOriginal.toFixed(4), { "thousandsGroupStyle": "thousand", "thousandSeparator": ".", "decimalSeparator": ",", "prefix": "UF " }),
            sortable: true,
            sortField: 'montoOriginal',
            wrap: true,
            alling: 'left',
            export: true,
        }, 
        {
            name: 'Valor operación',
            selector: (row: RowRecaudacionEndosoMasivo) => numericFormatter(row.valorOperacion.toFixed(4), { "thousandsGroupStyle": "thousand", "thousandSeparator": ".", "decimalSeparator": ",", "prefix": "UF " }),
            sortable: true,
            sortField: 'valorOperacion',
            wrap: true,
            alling: 'left',
            export: true,
        }, 
        {
            name: 'Monto a recaudar',
            selector: (row: RowRecaudacionEndosoMasivo) => numericFormatter(row.montoPago.toFixed(4), { "thousandsGroupStyle": "thousand", "thousandSeparator": ".", "decimalSeparator": ",", "prefix": "$ " }),
            sortable: true,
            sortField: 'montoPago',
            wrap: true,
            alling: 'left',
            export: true,
        }, 
    ]

    return {COLUMNS};
}